import {Button} from "@/components/ui/button.tsx";
import {LogIn, Play, Undo2} from "lucide-react";
import {ButtonGroup} from "@/components/ui/button-group.tsx";
import {useTurn} from "@/encounter/turns/TurnHooks.ts";

export default function NextTurnButton({onPrepareCombat}: {onPrepareCombat?: () => void} = {}) {
    const {round, startCombat, undoTurn, advanceTurn} = useTurn();

    if (round === 0)
        return (
            <Button type="button" onClick={() => onPrepareCombat ? onPrepareCombat() : void startCombat().catch(() => {})} size="icon"
                    variant="destructive" title={onPrepareCombat ? "Kampf vorbereiten" : "Kampf beginnen"}
                    aria-label={onPrepareCombat ? "Kampf vorbereiten" : "Kampf beginnen"}>
                <Play/>
            </Button>)

    return (
        <ButtonGroup>
            <Button type="button" onClick={() => void undoTurn().catch(() => {})} size="icon"
                    variant="warning" title="Vorheriger Zug (aktuelle Runde)" aria-label="Zug zurücknehmen">
                <Undo2/>
            </Button>
            <Button type="button" onClick={() => void advanceTurn().catch(() => {})} size="icon"
                    variant="warning" title="Nächster Zug" aria-label="Nächster Zug">
                <LogIn/>
            </Button>
        </ButtonGroup>
    )
}
